var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconDefaultProfile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icon_default_profile_svg__clip0_20140_95034)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 50C0 22.386 22.386 0 50 0s50 22.386 50 50-22.386 50-50 50S0 77.614 0 50z",
    fill: "#D1D1D1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78.145 76.875c5.238 5.234 6.089 17.053 6.23 28.097.04 3.459-2.759 6.278-6.224 6.278H21.842c-3.461 0-6.257-2.819-6.217-6.278.141-11.044.989-22.86 6.23-28.097 4.134-4.131 10.998-8.26 15.18-10.588 1.77-.987 2.104-3.353.716-4.834-4.344-4.631-6.514-8.537-6.514-18.953 0-9.375 6.254-18.75 18.76-18.75 12.512 0 18.766 9.375 18.766 18.75 0 10.416-2.17 14.322-6.514 18.953-1.388 1.481-1.053 3.847.716 4.834 4.182 2.329 11.046 6.457 15.18 10.588z",
    fill: "#9C9C9C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icon_default_profile_svg__clip0_20140_95034"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 50C0 22.386 22.386 0 50 0s50 22.386 50 50-22.386 50-50 50S0 77.614 0 50z",
    fill: "#fff"
  })))));
}

export default SvgIconDefaultProfile;